import React, { useState } from "react"
import tw, { css } from "twin.macro"
import ContentWrapper from "../../atoms/content-wrapper"
import AppIcon from "@atoms/icon"
import FloatingBox from "@atoms/floating-box"
import AppButton from "../../atoms/button"
import { FormattedMessage } from "react-intl"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Portal from "../../atoms/portal"
import PhotoGalleryOverlay from "./photo-gallery-overlay"

const coverImageStyles = [
  [
    tw`w-4/5`,
    css`
      @media (min-width: 640px) {
        width: 50%;
        margin-left: 40%;
      }
      @media (min-width: 1280px) {
        width: 60%;
        margin-left: 35%;
      }
    `,
  ],
  [
    tw`w-3/5 -mt-12`,
    css`
      margin-left: 40%;
      @media (min-width: 640px) {
        width: 30%;
        margin-left: 0;
        margin-top: -120px;
        float: right;
      }
    `,
  ],
]

const PhotoGalleryCover = ({ data }) => {
  const [showGallery, setShowGallery] = useState(false)
  const converImages = data.cover_images.map(image => ({
    id: image.id,
    image: getImage(image.localFile),
    alt: image.alternativeText,
  }))
  return (
    <div
      tw="relative px-6 pt-12 pb-24 sm:(pb-32 px-8) xl:(pt-24 pb-48)"
      css={css`
        background-color: black;
      `}
      className="tear-t-lg-black tear-b-lg-black"
    >
      <ContentWrapper tw="relative">
        {converImages.map((coverImage, index) => (
          <FloatingBox
            key={coverImage.id}
            css={coverImageStyles[index]}
            range={0.2 * index}
          >
            <GatsbyImage image={coverImage.image} alt={coverImage.alt} />
          </FloatingBox>
        ))}
        <h3 tw="-mt-40 relative max-w-screen-md sm:mt-0 sm:(absolute  left-6 top-0) xl:top-6 xxl:-left-16 xxxl:-left-24">
          <AppIcon
            name="camera"
            tw="w-20 h-20 -mb-4 -ml-4 text-brand-green block md:(w-24 h-24)"
          />
          <span
            tw="font-display block uppercase"
            css={[
              css`
                font-size: 5rem;
                line-height: 0.75;
                color: rgba(255, 255, 255, 0.17);
                @media (min-width: 640px) {
                  font-size: 6rem;
                }
                @media (min-width: 768px) {
                  font-size: 7rem;
                }
                @media (min-width: 1280px) {
                  font-size: 9rem;
                }
                @media (min-width: 1440px) {
                  font-size: 10rem;
                }
              `,
            ]}
          >
            {data.title}
          </span>
        </h3>
        <AppButton
          theme="secondary"
          suffix="arrow_right"
          tw="absolute bottom-12 right-6"
          css={css`
            @media (min-width: 640px) {
              position: relative;
              bottom: auto;
              right: auto;
              float: right;
              margin: 20px;
            }
          `}
          onClick={() => setShowGallery(true)}
        >
          <FormattedMessage id="open_gallery" defaultMessage="Open Gallery" />
        </AppButton>
      </ContentWrapper>
      {showGallery && (
        <Portal>
          <PhotoGalleryOverlay
            items={data.picture}
            onClose={() => setShowGallery(false)}
          />
        </Portal>
      )}
    </div>
  )
}

export const fragment = graphql`
  fragment PhotoGallery on FT_ComponentOrganismsPhotoGallery {
    id
    __typename
    title
    cover_images(limit: 2) {
      id
      url
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(width: 480, formats: [AUTO, WEBP, AVIF])
        }
      }
    }
    picture {
      ...GalleryPicture
    }
  }
`

export default PhotoGalleryCover
